import React from 'react'
import Button from '@retracedgmbh/ui-components-lib/Button'
import RadioButton from '@retracedgmbh/ui-components-lib/RadioButton'
import * as PropTypes from 'prop-types'
import useTranslator from '@/hooks/useTranslator'
import {supportedLanguages} from '@constants'
import Modal from '@components/TModal'

const LanguageSelectorModal = () => {
  const {switchLanguage} = useTranslator({page: 'profile'})
  const [selectedLanguage, setSelectedLanguage] = React.useState('en')
  const [isModalVisible, setIsModalVisible] = React.useState(true)

  return (
    <>
      <Modal
        isVisible={isModalVisible}
        closeOnOverlayClick={false}
        onRequestClose={() => {
          switchLanguage('en')
          setIsModalVisible(false)
        }}
        footer={<></>}
        header={
          <div style={{padding: 20}}>
            <h3>
              <b>Select your preferred language</b>
            </h3>
            <small>You can always change your language in your user settings.</small>
          </div>
        }
        size="sm"
      >
        <section className="modal-card-body" id="language-modal" style={{paddingBottom: 40, paddingTop: 20}}>
          <RadioButton
            options={supportedLanguages.selectArrayOptions}
            value={selectedLanguage}
            onChange={event => {
              setSelectedLanguage(event.target.value)
            }}
            direction="vertical"
          ></RadioButton>

          <div style={{paddingTop: 10, display: 'flex', flexDirection: 'row-reverse'}}>
            <Button
              color="primary"
              variant="fill"
              onClick={() => {
                switchLanguage(selectedLanguage)
                setIsModalVisible(false)
              }}
              id="set-up-language"
            >
              Set up
            </Button>
          </div>
        </section>
      </Modal>
    </>
  )
}

LanguageSelectorModal.defaultProps = {
  isOpen: false,
}

LanguageSelectorModal.propTypes = {
  isOpen: PropTypes.bool,
}
export default LanguageSelectorModal
